<script>
import { mapActions } from 'vuex';

import TableView from '@/components/elements/views/TableView';

export default {
    page: {
        title: 'Branches'
    },

    extends: TableView,

    data() {
        return {
            pageTitle: 'Branches'
        };
    },

    computed: {
        labels() {
            return [
                {
                    value: 'region.name',
                    text: 'Region',
                    width: '150px'
                },
                {
                    value: 'title',
                    width: '150px'
                },
                {
                    value: 'slug',
                    width: '150px'
                },
                {
                    text: 'Language',
                    value: 'language.code',
                    type: 'enum',
                    isLanguage: true,
                    enumOptions: [
                        { value: 'he', label: 'Hebrew' },
                        { value: 'en', label: 'English' },
                        { value: 'ar', label: 'Arabic' },
                        { value: 'ru', label: 'Russian' }
                    ]
                },
                {
                    value: 'isMain',
                    width: '150px',
                    type: 'boolean',
                    isBadge: true
                },
                {
                    value: 'email',
                    width: '150px'
                },
                {
                    value: 'address',
                    width: '150px'
                },
                {
                    value: 'phone',
                    width: '150px'
                },
                {
                    value: 'mobilePhone',
                    width: '150px'
                },
                {
                    value: 'status',
                    type: 'enum',
                    enumOptions: ['draft', 'published'],
                    width: '150px'
                },
                {
                    value: 'createdBy.fullName',
                    sortFieldName: 'createdBy.firstName',
                    text: 'Created By',
                    width: '150px'
                },
                {
                    value: 'editedBy.fullName',
                    sortFieldName: 'editedBy.firstName',
                    text: 'Edited By',
                    width: '150px'
                },
                {
                    value: 'createdAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                },
                {
                    value: 'updatedAt',
                    type: 'date',
                    filter: 'formatDate',
                    width: '150px'
                }
            ];
        }
    },

    methods: {
        ...mapActions({
            getItems: 'branches/index',
            deleteItem: 'branches/destroy'
        }),

        onRowClick({ id }) {
            this.$router.push(`/branches/${id}/edit`);
        },

        onAddButtonClick() {
            this.$router.push('/branches/add');
        }
    }
};
</script>
